var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoriesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.903 7.47906L8.98114 4.40213C8.79145 4.28357 8.55241 4.27729 8.3568 4.38572C8.16116 4.49416 8.03979 4.70027 8.03979 4.92398V11.0778C8.03979 11.3015 8.16116 11.5076 8.3568 11.6161C8.44975 11.6676 8.55245 11.6932 8.65503 11.6932C8.76836 11.6932 8.88152 11.6619 8.9811 11.5997L13.903 8.52275C14.0829 8.4103 14.1921 8.21309 14.1921 8.0009C14.1921 7.78872 14.0829 7.59151 13.903 7.47906ZM9.2703 9.96751V6.03426L12.4161 8.0009L9.2703 9.96751Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.924 0H3.07629C1.38009 0 0.00012207 1.38031 0.00012207 3.07692V12.9231C0.00012207 14.6197 1.38009 16 3.07629 16H17.924C19.6202 16 21.0001 14.6197 21.0001 12.9231V3.07692C21.0001 1.38031 19.6202 0 17.924 0ZM19.7697 12.9231C19.7697 13.941 18.9417 14.7692 17.924 14.7692H3.07629C2.05857 14.7692 1.23059 13.941 1.23059 12.9231V3.07692C1.23059 2.05895 2.05857 1.23077 3.07629 1.23077H17.924C18.9417 1.23077 19.7697 2.05895 19.7697 3.07692V12.9231Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoriesIcon);
export default __webpack_public_path__ + "static/media/memories-icon.5989e3507a612a239ad787617b9e3543.svg";
export { ForwardRef as ReactComponent };